<template>
  <div class="foot">
    <div class="container">
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" class="footbox">
          <div class="foot-item">
            <div>
              <div class="footer-content-list">
                <div class="footer-content-title">
                  <div class="title" @click="navto('/Aboutus')">
                    {{ language == "zh" ? "公司简介" : "About" }}
                  </div>
                </div>
                <ul class="footer-details footer-list">
                  <li @click="navto('/Aboutus?type=2')">
                    <a>{{ language == "zh" ? "关于我们" : "About us" }}</a>
                  </li>
                  <li @click="navto('/Aboutus?type=3')">
                    <a>{{ language == "zh" ? "经营理念" : "Core Value" }}</a>
                  </li>
                  <li @click="navto('/Aboutus?type=4')">
                    <a>{{
                      language == "zh" ? "资质荣誉" : "Qualifications"
                    }}</a>
                  </li>
                  <li @click="navto('/Aboutus?type=5')">
                    <a>{{
                      language == "zh" ? "设备环境" : "Plant&Facility"
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="foot-item">
            <div>
              <div class="footer-content-list">
                <div class="footer-content-title">
                  <div class="title" @click="navto('/Product')">
                    {{ language == "zh" ? "产品中心" : "Products" }}
                  </div>
                </div>
                <ul class="footer-details footer-list">
                  <li
                    :class="
                      item.disabled ? 'child-title-disabled' : 'child-title'
                    "
                    v-for="(item, i) in menu"
                    :key="i"
                    @click="
                      item.disabled ?'':navto(
                        '/ProductDetail?type1=' + item.value 
                      )
                    "
                  >
                    <a>{{ language == "zh" ? item.label : item.labelEn }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="foot-item">
            <div>
              <div class="footer-content-list">
                <div class="footer-content-title">
                  <div class="title" @click="navto('/Support')">
                    {{ language == "zh" ? "技术支持" : "Support" }}
                  </div>
                </div>
                <ul class="footer-details footer-list">
                  <li
                    v-for="(item, i) in jszc"
                    :key="i"
                    @click="navtoWithType('/Technical' ,'technical_menu_position', i)"
                  >
                    <a>{{ language == "zh" ? item.type : item.typeEn }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="foot-item">
            <div>
              <div class="footer-content-list">
                <div class="footer-content-title">
                  <div class="title" @click="navto('/News')">
                    {{ language == "zh" ? "新闻动态" : "News" }}
                  </div>
                </div>
                <ul class="footer-details footer-list">
                  <li
                    v-for="(item, i) in xwdt"
                    :key="i"
                    @click="navtoWithType('/News?' ,'news_menu_positon', i)"
                  >
                    <a>{{ language == "zh" ? item.type : item.typeEn }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="foot-item">
            <div>
              <div class="footer-content-list">
                <div class="footer-content-title">
                  <div class="title" @click="navto('/CallUs')">
                    {{ language == "zh" ? "联系我们" : "Contact" }}
                  </div>
                </div>
                <ul class="footer-details footer-list">
                  <li @click="navtoWithType('/CallUs','callus_menu_position',0)">
                    <a>{{ language == "zh" ? "联系方式" : "Contact Info" }}</a>
                  </li>
                  <li @click="navtoWithType('/CallUs','callus_menu_position',1)">
                    <a>{{ language == "zh" ? "招聘信息" : "Recruitment" }}</a>
                  </li>
                  <li
                    v-for="(item, i) in lxwm"
                    :key="i"
                    @click="navtoWithType('/CallUs' ,'callus_menu_position', i+2)"
                  >
                    <a>{{ language == "zh" ? item.type : item.typeEn }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" class="foot-right">
          <div class="logo" @click="navto('/')">
            <img src="../../static/img/资源 26.png" class="foot-logo" />
          </div>
          <div class="icon">
            <img
              src="../../static/img/21.png"
              class="qrcode"
              v-show="active == 0"
            />
            <img
              src="../../static/img/22.png"
              class="qrcode"
              v-show="active == 1"
            />
            <img
              src="../../static/img/20.png"
              class="qrcode"
              v-show="active == 2"
            />
            <div>
              <img
                src="../../static/img/资源 23.png"
                @mouseenter="qrcode(0)"
                v-show="active != 0"
                class="foot-icon"
              />
              <img
                src="../../static/img/资源 24.png"
                @mouseenter="qrcode(1)"
                class="foot-icon"
                v-show="active != 1"
              />
              <img
                src="../../static/img/资源 25.png"
                @mouseenter="qrcode(2)"
                class="foot-icon"
                v-show="active != 2"
              />
            </div>
          </div>
          <div class="test" v-if="language == 'zh'">
            版权所有<span class="banquan">©</span
            >2022&ensp;海德贝液压技术(浙江)有限公司<span>&ensp;浙ICP备 2022015880号-1</span>
          </div>
          <div class="test" v-else>
            copyright<span class="banquan">©</span>2022&ensp;&ensp;HydraBase
            Tech（Zhejiang）Co., Ltd&ensp;<span
              >ZhejiangICP preparation 2022015880-1</span
            >
          </div>
        </el-col>
      </el-row>
      <p></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      jszc: [],
      xwdt: [],
      lxwm: [],
    };
  },
  props: {
    language: {
      type: String,
      default: "",
    },
    menu: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.getInfo();
    // this.getcallus()
  },
  methods: {
    // getcallus() {
    //   this.$http
    //     .get("/hdbs/api/contacts/company", {

    //     })
    //     .then(
    //       function (response) {
    //         var status = response.data.code;
    //         if (status === 0) {
    //           this.contact = response.data.data[0]
    //         }
    //       }.bind(this)
    //     )
    // },
    qrcode(i) {
      this.active = i;
    },
    navto(path) {
      this.$router.push(path);
    },
    navtoWithType(path,type,position) {
      localStorage.setItem(type, position)
      this.$router.push(path+'?type='+position);
    },
    getInfo() {
      this.$http
        .get("/hdbs/api/activity/type/list", {
          params: {
            parentType: "技术支持",
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.jszc = response.data.data.filter((x) => {
                return x.parentType == "技术支持"||x.parentType == "技术支持说明";
              });
              this.xwdt = response.data.data.filter((x) => {
                return x.parentType == "新闻动态";
              });
              this.lxwm = response.data.data.filter((x) => {
                return x.parentType == "联系我们";
              });
            }
          }.bind(this)
        );
    },
  },
};
</script>
<style lang="stylus" scoped>
.footbox {
  display: flex;

  .foot-item {
    flex: 1;
  }
}

.foot-qrcode {
  width: 12rem;
  border-radius: 6px;
  padding: 3px;
  background: #fff;
}

.icon {
  position: relative;

  .qrcode {
    width: 12rem;
  }

  .foot-icon {
    position: absolute;
    bottom: 0;
    width: 2rem;
    height: 2rem;
    object-fit: contain;
  }

  .foot-icon:nth-child(1) {
    right: 9rem;
  }

  .foot-icon:nth-child(2) {
    right: 4.5rem;
  }

  .foot-icon:nth-child(3) {
    right: 0rem;
  }
}

.test {
  margin-top: 2rem;
  color: #FFFFFF80;
}

.child-title-disabled {
  a{
    color: #FFFFFF25 !important;
    cursor: not-allowed;
  }
  font-family: Regular;
}

.child-title-disabled:hover {
  a{
    color: #FFFFFF25 !important;
    cursor: not-allowed;
  }
  font-family: Regular;
}
.title{
  cursor pointer;
}
.logo{
  cursor pointer;
}
@media screen and (max-width: 1200px) {
  .footbox {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Foot.vue